module.exports = __webpack_public_path__ + "img/pdf.53f39da2.png";